import { Vector3 } from "three";
import { SceneGraphNode } from "../internal";
/**
 * Camera root object
 *
 * @class Camera
 * @param {Object} parentNode
 * @extends {SceneGraphNode}
 * @constructor
 */
export class Camera extends SceneGraphNode {
    constructor(parentNode) {
        super(parentNode);
    }
    getPosition() {
        return new Vector3(0, 0, 0);
    }
    getOrientation() {
        return new Vector3(0, 0, 0);
    }
    getPositionAbsolute() {
        return new Vector3(0, 0, 0);
    }
    getZoomLevel() {
        return 1.0;
    }
    getWidth() {
        return 0;
    }
    getHeight() {
        return 0;
    }
    getLatLon() {
        return [0, 0, 0];
    }
    destroy() {
        super.destroy();
    }
}
//# sourceMappingURL=camera.js.map